<template>
  <div class="assets" @scroll="handleScroll">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang458') }}</span>
    </div>
    <div class="total_box" v-if="list.length > 0">
      <div class="item" v-for="(item, index) in list" :key="index" @click="toPage(item)">
        <img :src="item.product_image" alt="" />
        <van-count-down
          class="count2"
          v-if="new Date().getTime() < item.start_time * 1000"
          :time="item.start_time * 1000 - new Date().getTime()"
          :format="item.start_time * 1000 - new Date().getTime() > 86400000
          ? `${$t('lang465')} DD ${$t('lang9')} HH ${$t('lang10')} mm ${$t('lang11')} ss ${$t('lang12')}`
          : `${$t('lang465')} HH ${$t('lang10')} mm ${$t('lang11')} ss ${$t('lang12')}`"
        />
        <van-count-down
          v-else-if="new Date().getTime() > item.start_time * 1000 && new Date().getTime() < item.end_time * 1000"
          class="count1"
          :time="item.end_time * 1000 - new Date().getTime()"
          :format="item.end_time * 1000 - new Date().getTime() > 86400000
          ? `${$t('lang466')} DD ${$t('lang9')} HH ${$t('lang10')} mm ${$t('lang11')} ss ${$t('lang12')}`
          : `${$t('lang466')} HH ${$t('lang10')} mm ${$t('lang11')} ss ${$t('lang12')}`"
        />
        <span class="count3" v-else>{{ $t('lang467') }}</span>
      </div>
    </div>
    <div class="bare" v-else>
      <span>{{ $t('lang60') }}</span>
    </div>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { Dialog, Notify } from 'vant';
export default {
  data() {
    return {
      page: 1,
      list: [],
    };
  },
  mounted() {
    this.getWelfareRedeList();
  },
  methods: {
    //返回上一页
    back() {
      if (window.history.length <= 1) {
      // 如果没有历史记录，可以跳转到默认页
        this.$router.replace('/'); 
      } else {
        this.$router.back();
      }
    },
    navigation(name, query) {
      this.$router.push({ name, query });
    },
    toPage(item) {
      if (new Date().getTime() > item.start_time * 1000 && new Date().getTime() < item.end_time * 1000) {
        this.navigation('exchange', { id: item.id });
      }
    },
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 滚动距离
      const scrollHeight = container.scrollHeight; // 内容总高度
      const clientHeight = container.clientHeight; // 可视区域高度
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        console.log('Bottom', this.page);
        if (this.page != -1) {
          this.page++; // 页数加 1
          this.getWelfareRedeList(); // 触发加载更多
        }
      }
    },
    getWelfareRedeList() {
      homeApi.getWelfareRedeList({ page: this.page }).then(res => {
        if (res.code == 200) {
          console.log(res.data.data);

          if (this.list.length >= res.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.list = [...this.list, ...res.data.data];
            if (this.list.length >= res.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 15px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f {
  display: flex;
  align-items: center;
}
.assets {
  height: 100vh;
  overflow: auto;
  padding: 50px 0 0;
  background-color: #f6f6f6;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }

  .total_box {
    font-size: 13px;
    color: #fff;
    // height: 140px;
    // border-radius: 16px;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 14px 14px;
    .item {
      position: relative;
      margin-bottom: 6px;
    }
    img {
      width: 100%;
      border-radius: 10px;
    }

    .count1 {
      color: #fff;
      font-size: 12px;
      position: absolute;
      bottom: 3.2px;
      right: 0;
      max-width: 76%;
      padding: 3px 10px;
      border-radius: 10px 0 10px 0;
      background-color: #29b286;
    }
    .count2 {
      color: #fff;
      font-size: 12px;
      position: absolute;
      bottom: 3.2px;
      right: 0;
      max-width: 76%;
      padding: 3px 10px;
      border-radius: 10px 0 10px 0;
      background-color: #1B9AEE;
    }
    .count3 {
      color: #fff;
      font-size: 12px;
      position: absolute;
      bottom: 3.2px;
      right: 0;
      max-width: 76%;
      min-width: 100px;
      text-align: center;
      padding: 3px 10px;
      border-radius: 10px 0 10px 0;
      background-color: #8f8f8f;
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }
}
.wrapper {
  // display: flex;
  // justify-content: center;
  .loading {
    position: absolute;
    left: 46%;
    top: 46%;
  }
}
</style>